import React, { useState } from "react";
import classNames from "classnames";

import { BettingTypeGroupBody } from "./BettingTypeGroupBody";

import BettingTypeGroupHeaderInfo from "./BettingTypeGroupHeaderInfo";

export function BettingTypeGroup(props: {
	group: Parameters<typeof BettingTypeGroupHeaderInfo>[0]["group"] &
		Parameters<typeof BettingTypeGroupBody>[0]["group"];
	isFavorite?: boolean;
}) {
	const [isExpanded, setExpand] = useState(true);

	const containerElClasses = classNames("offer offer--additional", {
		"is-collapsed": !isExpanded,
		"is-expanded": isExpanded,
	});

	return (
		<div className={containerElClasses}>
			<BettingTypeGroupHeaderInfo
				isExpanded={isExpanded}
				onSetExpand={setExpand}
				group={props.group}
				isFavorite={props.isFavorite}
			/>
			<BettingTypeGroupBody
				isExpanded={isExpanded}
				group={props.group}
				isFavorite={props.isFavorite}
			/>
		</div>
	);
}
